<template>
    <div class="modal modal-color premium-features-modal">
      <div class="modal-dialog">
        <span v-if="showClose && !isAndroid" class="modal-close pointer" @click="goBack"><i class="icon-close"></i></span>
        <span v-if="isAndroid" class="back-btn pointer" @click="goBack">{{ $lang.messages.back }}</span>
        <div class="modal-content">
          <VueSlickCarousel ref="carousel" class="premium-features-slider"
                             :infinite="false" :adaptiveHeight="false" :arrows="!isAndroid" :dots="true">
            <div class="premium-features-slider-item">
              <img src="../assets/img/popup-dashboard.svg" alt="Premium feature">
              <div class="premium-features-slider-title">{{ $lang.messages.premium_features.slide_1.title }}</div>
              <ul class="premium-features-list">
                <li>{{ $lang.messages.premium_features.slide_1.text_1 }}</li>
                <li>{{ $lang.messages.premium_features.slide_1.text_2 }}</li>
              </ul>
            </div>
            <div class="premium-features-slider-item">
              <img src="../assets/img/premium-slider-2.png" alt="Premium feature">
              <div class="premium-features-slider-title">{{ $lang.messages.premium_features.slide_2.title }}</div>
              <ul class="premium-features-list">
                <li>{{ $lang.messages.premium_features.slide_2.text_1 }}</li>
                <li>{{ $lang.messages.premium_features.slide_2.text_2 }}</li>
                <li>{{ $lang.messages.premium_features.slide_2.text_3 }}</li>
                <li>{{ $lang.messages.premium_features.slide_2.text_4 }}</li>
              </ul>
            </div>
            <div class="premium-features-slider-item">
              <img src="../assets/img/premium-slider-3.png" alt="Premium feature">
              <div class="premium-features-slider-title">{{ $lang.messages.premium_features.slide_3.title }}</div>
              <ul class="premium-features-list">
                <li>{{ $lang.messages.premium_features.slide_3.text_1 }}</li>
                <li>{{ $lang.messages.premium_features.slide_3.text_2 }}</li>
                <li>{{ $lang.messages.premium_features.slide_3.text_3 }}</li>
              </ul>
            </div>
            <div class="premium-features-slider-item">
              <img src="../assets/img/premium-slider-4.png" alt="Premium feature">
              <div class="premium-features-slider-title">{{ $lang.messages.premium_features.slide_4.title }}</div>
              <ul class="premium-features-list">
                <li>{{ $lang.messages.premium_features.slide_4.text_1 }}</li>
                <li>{{ $lang.messages.premium_features.slide_4.text_2 }}</li>
                <li>{{ $lang.messages.premium_features.slide_4.text_3 }}</li>
              </ul>
            </div>
          </VueSlickCarousel>
          <div class="text-center position-relative">
            <button class="btn btn-main -shadow" @click="$emit('gettrial')">{{ $lang.messages.premium_features.try_trial }}</button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

export default {
  name: 'PremiumFeaturesModal',
  data: function () {
    return {
      isAndroid: window.Android
    }
  },
  props:  {
    showClose: {
      type: Boolean,
      default: true,
    }
  },
  methods: {
    hideModal () {
      this.$emit('hidemodal')
    },
    goBack(){
      this.$emit('goback')
    }
  },
  components: {VueSlickCarousel}
}
</script>

<style lang="scss">
@import "../assets/styles/helpers";
.premium-features {
  &-modal {
    .back-btn {
      position: absolute;
      left: 15px;
      top: 15px;
      z-index: 1;
    }
    .modal-dialog {
      &:before {
        content: "";
        display: block;
        width: 200%;
        height: 200%;
        border-radius: 50% 30%;
        background: #fff;
        position: absolute;
        right: 0;
        top: 0;
      }
    }
  }

  &-slider {
    width: 426px;
    margin: 0 auto 30px;
    text-align: center;

    &-title {
      font-size: 24px;
      font-weight: 800;
      color: #7D6AED;
      margin-bottom: 5px;
    }

    img {
      margin: 15px auto;

      @include responsive-below-height('700px'){
        max-height: 140px;
      }
    }

    .slick-arrow {
      width: 62px;
      height: 62px;
      border: solid 1px #8d7cef;
      border-radius: 50%;

      &:before {
        content: "";
        display: inline-block;
        width: 8px;
        height: 8px;
        border: solid 2px #8d7cef;
        border-top: 0;
        border-right: 0;
        margin-left: 4px;
        transform: rotate(45deg);
      }
    }

    .slick-next {
      right: -70px;

      &:before {
        margin-left: -4px;
        transform: rotate(225deg);
      }
    }

    .slick-prev {
      left: -70px;
    }

    .slick-dots{
      bottom: -15px;


      li {
        $button-width: 48px;
        width: $button-width;

        button {
          width: $button-width;
          &:before {
            content: "";
            background: #B4B6E4;
            border-radius: 6px;
            width: $button-width;
            height: 3px;
          }
        }
      }


      li.slick-active button:before {
        background: #7B66F6;
      }
    }

  }

  &-list {
    text-align: left;
    margin-left: auto;
    margin-right: auto;
    font-size: 18px;
    padding-left: 20px;
  }
}

</style>


